window.InifECShared.directive('delayedDirectiveLoader', ['$rootScope',
    function($rootScope) {
        return {
            restrict: 'AE',
            transclude: true,
            replace: true,
            template: '',

            terminal: true,
            link: function(scope, element, attr, ctrls, transclude) {
                $rootScope.$on('LOAD_ALL_MODALS', function(event, data) {

                    transclude(scope, function(clone) {
                       // clone is your transluded content
                        // delayed compile html and append it back to body
                        requestAnimationFrame(function() {
                            $('body').append(clone);
                        })
                    });     
                })

            }
        };
    }
]);
